"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _TVPBHOOYcjs = require('../__chunks/TVPBHOOY.cjs');


var _6E4BBKC4cjs = require('../__chunks/6E4BBKC4.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/radio/radio-group.tsx
var _misc = require('@ariakit/core/utils/misc');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useRadioGroup = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useRadioGroup2({ store, ...props }) {
    const context = _TVPBHOOYcjs.useRadioProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "RadioGroup must receive a `store` prop or be wrapped in a RadioProvider component."
    );
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _TVPBHOOYcjs.RadioScopedContextProvider, { value: store, children: element }),
      [store]
    );
    props = {
      role: "radiogroup",
      ...props
    };
    props = _6E4BBKC4cjs.useComposite.call(void 0, { store, ...props });
    return props;
  }
);
var RadioGroup = _PTOCUU2Dcjs.forwardRef.call(void 0, function RadioGroup2(props) {
  const htmlProps = useRadioGroup(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.RadioGroup = RadioGroup; exports.useRadioGroup = useRadioGroup;
